// [former agency view, receiving agency view]
const labels = {
	pending: ['Waiting for receiving agency to accept', 'Waiting for you to accept'],
	accepted: [
		'Accepted – release to finish',
		'Accepted – waiting for the former agency to release',
	],
	declined: ['Declined', 'Declined'],
	cancelled: ['Cancelled', 'Cancelled'],
	released: ['Released', 'Transferred to your agency'],
	expired: ['Expired', 'Expired'],
};

export const transferStatusLabel = (status, incoming) =>
	labels[status]?.[incoming ? 1 : 0] || status;

export const isOpenTransfer = (status) =>
	status === 'pending' || status === 'accepted';
